import axiosInstance from "../utils/axiosInstance";

export const fetchFavorites = async () => {
    try {
        const response = await axiosInstance.get(`/api/favorites`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching favorites:', error);
        return [];
    }
};